import { render, staticRenderFns } from "./ProjectReports.vue?vue&type=template&id=1b1d313d&scoped=true"
import script from "./ProjectReports.vue?vue&type=script&lang=js"
export * from "./ProjectReports.vue?vue&type=script&lang=js"
import style0 from "./ProjectReports.vue?vue&type=style&index=0&id=1b1d313d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d313d",
  null
  
)

export default component.exports